module.exports = __webpack_public_path__ + "assets/img/yb.939cdd95.png";